export default function getBasePath (): string {
  return '/fahrten'
}
